<template>
  <div class="query-record">
    <div class="query-record-container">
      <div class="header-box">
        <span class="recharge-date">查询日期</span>
        <kx-date-picker
          v-model="params.beginDate"
          :no3Month="true"
          :time-end.sync="params.endDate"/>
        <!--
        <el-date-picker
          class="btn-date-picker"
          v-model="time"
          type="daterange"
          :editable="false"
          :clearable="false"
          align="center"
          range-separator="-"
          placeholder="选择日期范围"
          :picker-options="pickerOptions"
        ></el-date-picker>
        -->
        <el-select
          class="ml10"
          v-model="params.country"
          placeholder="请选择站点"
          size="mini"
          clearable
          @change="orderList"
        >
          <el-option
            v-for="el in countryList"
            :key="el.cnt"
            :label="el.name"
            :value="el.cnt"
          ></el-option>
        </el-select>
        <el-button @click="orderList" v-pointerReClick>查询</el-button>
        <!-- <div class="search-tip">注：仅可查询一个月数据</div> -->
        <!-- <div class="search-tip">每次查询搜索的结果保留24个小时，从关键词搜索链接开始计时</div> -->
      </div>
      <div class="table-box">
        <el-table
          :data="tableData"
          v-loading="loading"
          border
          style="width: 100%"
          :height="getStyle"
          :header-cell-style="{ background: '#eef1f6' }"
        >
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column
            prop="payDate"
            label="查询日期"
            align="center"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="histQueryExpireDate"
            label="过期日期"
            align="center"
            width="180"
          ></el-table-column>
          <el-table-column label="内容" align="center">
            <template slot-scope="scope">
              <div
                :class="[
                  'align-left',
                  scope.row.goodsUrl ? 'table-oper-txt' : '',
                ]"
                @click="handleDownLoad(scope.row)"
              >
                {{ getSearchTxt(scope.row) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="175">
            <template slot-scope="scope">
              <div class="align-left">
                <span v-if="scope.row.isshow" class="load">
                  <i class="el-icon-loading"></i>
                </span>
                <span
                  class="table-oper-txt"
                  @click="targetHome(scope.row)"
                  v-else-if="getIsShow(scope.row.histQueryExpireDate)"
                  >重新查询</span
                >
                <el-popover
                  v-else
                  placement="bottom"
                  width="300"
                  trigger="hover"
                  content="超过72小时，无法重新查询，如有疑问，请联系右侧客户经理"
                >
                  <span class="table-disabled" slot="reference">重新查询</span>
                </el-popover>
                <span class="history" @click="historyClick(scope.row)"
                  >历史记录</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="1"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <tip-dv :tipDv="tipDv" @closeTipDv="closeTipDv" />
    <rowTableData
      :historyDV="historyDV"
      :rowTableDataList="rowTableDataList"
      @closeHistoryDV="closeHistoryDV"
    ></rowTableData>
  </div>
</template>

<script>
import { querySearchList, getOrderHistory } from '@/api/user.js'
import { setItem } from '@/utils/storage'
import { myMixin } from '@/mixins/mixin.js'
import {
  countryer,
  batchSearchRepeat,
  importProcess
  // downloadImportQuery
} from '@/api/home'
import TipDv from '../Home/components/tip-dv.vue'
import rowTableData from './components/rowTableData.vue'
import KxDatePicker from '@/components/KxDatePicker'
import { diffDate } from '@/utils/day.js'
export default {
  name: 'queryRecord',
  components: { TipDv, rowTableData, KxDatePicker, },
  props: {},
  mixins: [myMixin],
  data() {
    return {
      countryList: [],
      historyDV: false,
      rowTableDataList: [],
      tipDv: false,
      processId: null,
      timeId: null,
      params: {
        country: '',
        pageNo: 1,
        pageSize: 10,
        beginDate: '',
        endDate: ''
      },
      time: ['', ''],
      tableData: [],
      total: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
    }
  },
  computed: {
    getStyle() {
      if (this.tableData.length > 0) {
        return '100%'
      } else {
        return 'auto'
      }
    }
  },
  destroyed() {
    clearInterval(this.processId)
    clearTimeout(this.timeId)
  },
  watch: {},
  created() {
    /*
    this.time = [new Date(this.getDateStr(30)), new Date()]
    */
    this.params = Object.assign(this.params, {
      beginDate: this.format(new Date(this.getStartDate(30))),
      endDate: this.format(new Date())
    })
    this.orderList()
    this.getCountry()
  },
  methods: {
    async getCountry() {
      const res = await countryer()
      const { code, data } = res
      if (code == 200) {
        this.countryList = data
      }
    },
    // 关闭温馨提示
    closeTipDv() {
      this.tipDv = false
    },
    // 查看历史记录
    async historyClick(row) {
      // if (row.searchResponse) {
      //   this.historyDV = true
      //   this.rowTableDataList = row.searchResponse
      // }
      if (row.type == 7) {
        if (row.goodsUrl) {
          window.open(row.goodsUrl)
        }
      } else {
        let res = await getOrderHistory({ orderNo: row.orderNo })
        if (res.success) {
          this.historyDV = true
          let list = []

          res.data.forEach(el => {
            let { queryTime } = el
            el.searchResponse.forEach(item => {
              item.queryTime = queryTime
              list.push(item)
            })
          })

          this.rowTableDataList = list
          // this.rowTableDataList = res.data.searchResponse
        }
      }
    },
    // 关闭历史记录弹框
    closeHistoryDV() {
      this.historyDV = false
    },
    // 获取使用记录信息
    orderList() {
      this.loading = true
      const { beginDate, endDate } = this.params
      const days = diffDate(beginDate, endDate)
      if (days > 31) {
        return this.$message.warning('仅可查询一个月内的数据')
      }
      /*
      this.params.beginDate = this.format(this.time[0])
      this.params.endDate = this.format(this.time[1])
      */
      querySearchList(this.params).then(res => {
        this.loading = false
        if (res.success) {
          this.tableData = res.data.data || []
          this.total = res.data.totalRecord
        }
      })
    },
    async targetHome(row) {
      if (row.type == 7) {
        let res = await batchSearchRepeat({ orderNo: row.orderNo })
        this.$set(row, 'isshow', true)
        if (res.success) {
          this.processId = setInterval(async () => {
            let res2 = await importProcess(res.data.taskId)
            if (res2.data == 1 || res2.data == -1) {
              clearInterval(this.processId)
              clearInterval(this.timeId)
              this.$set(row, 'isshow', false)
              this.$message.success('重新查询成功！')
              this.$router.push('/use-record')
            }
          }, 1000)
          this.timeId = setTimeout(() => {
            this.tipDv = true
          }, 300000)
        } else {
          this.$set(row, 'isshow', false)
        }
      } else {
        setItem('row', row.searchRequest)
        console.log(row,row.searchRequest);
        this.$router.push('/home')
      }
    },
    getIsShow(time) {
      return +new Date() >= new Date(time) ? false : true
    },
    getSearchTxt(val) {
      if (val.type == 7) {
        return '点击下载查询结果'
      } else {
        return val.content
      }
      // if (val.searchType == 0) {
      //   return 'Profile：' + val.profileId
      // } else if (val.searchType == 7) {
      //   return '点击下载导入表格'
      // } else {
      //   return `Name：${val.username} Helpful Votes：${
      //     val.helpfulVoteNumber
      //   } Reviews：${val.reviewNumber} Addr：${val.location ||
      //     ''} Review Date：${val.latestReviewDate ||
      //     ''} Profile：${val.profileId || ''}`
      // }
    },
    handleDownLoad(row) {
      if (row.type == 7) {
        window.open(
          process.env.VUE_APP_BASEURL +
          `/api/order/downloadImportQuery?orderNo=${row.orderNo}`
        )
      }
    },
    handleSizeChange(val) {
      this.params.pageSize = val
      this.orderList()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val
      this.orderList()
    }
  }
}
</script>

<style scoped lang="scss">
.query-record {
  position: relative;
  width: 1010px;
  height: 100%;
  padding: 20px;
  box-shadow: 0px 2px 12px 0px #edecf6;
  border-radius: 4px;
  .history {
    margin-left: 20px;
    cursor: pointer;
    color: #0668f6;
  }
  .query-record-container {
    height: 100%;
  }
  .header-box {
    display: flex;
    align-items: center;
    position: relative;
    .recharge-date {
      margin-right: 22px;
    }
    .el-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 66px;
      height: 30px;
      background-color: #3c7cff;
      border-color: #3777ff;
      color: #fff;
      margin: 0 0 0 22px;
    }
    ::v-deep.el-input__inner {
      width: 180px;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
    }

    .search-tip {
      position: absolute;
      right: 0;
      top: 5px;
      font-size: 14px;
      font-weight: 400;
      color: #999;
      /*
      color: #fdb944;
      */
    }
  }
  ::v-deep.el-date-editor {
    width: 200px !important;
    height: 30px;
    line-height: 30px !important;
    font-size: 12px !important;

    .el-range-input {
      font-size: 12px;
    }

    .el-icon-date {
      margin-top: -8px;
      &::before {
        margin-right: -360px;
      }
    }

    .el-range__icon {
      margin-left: -22px;
    }

    .el-range-separator {
      line-height: 22px;
    }
  }
  .table-box {
    height: calc(100% - 100px);
    margin-top: 20px;
    ::v-deep.has-gutter {
      color: #373e4f;
    }
    .table-oper-txt {
      cursor: pointer;
      color: #0668f6;
    }
    .table-disabled {
      cursor: no-drop;
      color: #a3aab7;
    }
    .block {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .align-left {
      text-align: left !important;
    }
    .load {
      text-align: center;
      .el-icon-loading {
        width: 56px;
        color: #0668f6;
      }
    }
  }
}
</style>
